const ChartIcon = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <svg
        width={"1em"}
        height={"1em"}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5 17.5H8.33333C5.58347 17.5 4.20854 17.5 3.35427 16.6457C2.5 15.7914 2.5 14.4165 2.5 11.6667V2.5"
          stroke="currentColor"
          stroke-width="1.25"
          stroke-linecap="round"
        />
        <path
          d="M5 10H5.00748M7.4985 10H7.50598M9.997 10H10.0045M12.4955 10H12.503M14.994 10H15.0015M17.4925 10H17.5"
          stroke="currentColor"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5 5.83317C5.56123 4.89856 6.3226 4.1665 7.49402 4.1665C12.4466 4.1665 9.66283 14.1665 14.9849 14.1665C16.1647 14.1665 16.9214 13.4296 17.5 12.4998"
          stroke="currentColor"
          stroke-width="1.25"
          stroke-linecap="round"
        />
      </svg>
    </div>
  );
};

export default ChartIcon;
